// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import VueRouter from 'vue-router'
import routes from './router'
import * as Cookies from 'js-cookie'
import store from './store'
import i18n from './lang.js'
import VueProgressBar from 'vue-progressbar'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueLodash from 'vue-lodash'
import Notifications from 'vue-notification'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

Vue.use(BootstrapVue)
Vue.use(Cookies)
Vue.use(VueRouter)
Vue.use(VueProgressBar, {
  autoFinish: false
})
Vue.use(VueMoment, {
  moment
})
Vue.use(VueLodash)

Vue.config.productionTip = false

const router = routes
Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: {
    request: function (req, token) {
      let info = JSON.parse(atob(token))
      this.options.http._setHeaders.call(this, req, {Token: info.token})
    },
    response: function (res) {
      if (res.data.data == null || res.data.data.length == 0 || res.data.data.key == null) {
        return null
      }
      let token = res.data.data.token
      let key = res.data.data.key
      let info = {
        token: token.trim(),
        key: JSON.parse(atob(key.trim()))
      }
      Vue.axios.defaults.headers.common['Market'] = info.key.client_id
      return btoa(JSON.stringify(info))
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {
    url: process.env.BASE_URL_USER + '/ch_login',
    method: 'POST',
    redirect: '/',
    fetchUser: false
  },
  logoutData: {
    url: process.env.BASE_URL_USER + '/ch_logout',
    method: 'POST'
  },
  refreshData: {
    enabled: false
  },
  fetchData: {
    enabled: false,
    success: function (res) {
      let info = Vue.auth.token()
      info = JSON.parse(atob(info))
      info.key.group = info.key.roles
      info.key.roles = info.key.permissions
      info.key.store_code = info.key.info.outlets.length > 0 ? info.key.info.outlets[0] : ''
      Vue.axios.defaults.headers.common['Market'] = info.key.info.client_id
      Vue.auth.user(info.key)
    }
  },
  notFoundRedirect: {
    path: '/pages/404'
  },
  forbiddenRedirect: {
    path: '/pages/404'
  }
})


Vue.filter('json', value => { return JSON.stringify(value, null, 2) })

Vue.use(Notifications)

Vue.use(vueNumeralFilterInstaller)

const main = new Vue({
  i18n,
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
window.Vue = Vue
main.$i18n.locale = main.$session.get('lang') || 'en'
Vue.axios.defaults.headers.common['Lang'] = main.$session.get('lang') || 'en'

export default main



// WEBPACK FOOTER //
// ./src/main.js